/* eslint-disable complexity */
// Copyright (c) 2016 Deere & Company

import './new-transfer-dealer.scss';
import React, {PropTypes} from 'react';
import Dealer from '@deere/cps-it.warranty-model-factory/lib/dealer';

export const buildCityStateZip = address => address.city ? `${address.city}, ${address.state ? address.state : ''}` : '';

const DealerDetailsInfo = ({dealer}) =>
    <section className='new-transfer-dealer-details'>
        <div className='dealer-name'>
            {dealer.name && `${dealer.name}, ${dealer.account ? dealer.account : ''}`}
        </div>
        <div className='dealer-address'>
            {dealer.location && dealer.location.address1 ? dealer.location.address1 : ''}
        </div>
        <div className='dealer-city-state-zip'>
            {dealer.location && buildCityStateZip(dealer.location)}
        </div>
        <div className='dealer-email'>
            {dealer.email && dealer.email}
        </div>
        <div className='dealer-country'>
            {dealer.location && dealer.location.country ? dealer.location.country : ''}
        </div>
        <div className='dealer-country'>
            {dealer.location && dealer.location.postalCode ? dealer.location.postalCode : ''}
        </div>
        <div className='dealer-phone'>
            {dealer.phone && dealer.phone}
        </div>
    </section>;

DealerDetailsInfo.displayName = 'DealerDetailsInfo';
DealerDetailsInfo.propTypes = {
    dealer: PropTypes.instanceOf(Dealer).isRequired
};

export default DealerDetailsInfo;



// WEBPACK FOOTER //
// ./src/rga/recalled-part-analysis/components/advance-returned-part-information/recalled-part-tab/components/dealer-info-details.js